import { Component, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import {
   listenToRecording,
   ListenToRecordingModel,
} from 'src/app/pages/call-logs-register/state/call-logs-register.actions';
import { getCallRecordingsLCSPrivileges, getCallRecordingsPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { ActiveCallsRegister } from '../../active-calls-register';
import { ActiveCallsFilterOptions } from '../../models/active-calls-filter-option';
import { CallRecordingsPrivileges, LCSCallRecordingsPrivileges } from '../../models/call-recordings-privileges';
import * as AccountCallHistoryActions from '../../state/account-call-history/account-call-history.actions';
import * as accountCallHistoryRegisterReducer from '../../state/account-call-history/account-call-history.reducer';
import { selectSortedActiveCalls } from '../../state/account-call-history/account-call-history.selectors';
@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-account-call-history-register',
   templateUrl: './account-call-history-register.component.html',
   standalone: false,
})
export class AccountCallHistoryRegisterComponent extends ActiveCallsRegister {
   entityName = 'Call History';

   callRecordingsPrivileges$: Observable<CallRecordingsPrivileges>;

   callRecordingsLCSPrivileges$: Observable<LCSCallRecordingsPrivileges>;

   constructor(public store: Store) {
      super(
         store,
         accountCallHistoryRegisterReducer.selectors,
         AccountCallHistoryActions.accountCallHistoryRegisterAdapterActions
      );
      this.dataSource$ = this.store.pipe(select(selectSortedActiveCalls));
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: ActiveCallsFilterOptions[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
      this.columns = [
         'startTime',
         'callDuration',
         'callSource',
         'callDestination',
         'destinationNumber',
         'callDispositionTypeId',
         'callDirection',
         'sourceProvider',
         'destinationProvider',
         'callHistoryActionsMenu',
      ];

      this.callRecordingsPrivileges$ = store.pipe(select(getCallRecordingsPrivileges));
      this.callRecordingsLCSPrivileges$ = store.pipe(select(getCallRecordingsLCSPrivileges));
   }

   onOpenDialog(event: { callLogs: any }) {
      this.store.dispatch(AccountCallHistoryActions.openDialog(event));
   }

   onListen(event: ListenToRecordingModel) {
      this.store.dispatch(listenToRecording({ callRecording: event }));
   }

   getInitialFilterAction() {
      return AccountCallHistoryActions.callHistoryRegisterInitialFilter({ filters: this.filters });
   }
   getCreateAction() {}
}
